import React from 'react';

interface LiveIconProps {
  className?: string;
}

export const LiveIcon: React.FC<LiveIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer circle stroke */}
      <circle cx="8" cy="8" r="7" stroke="#01A925" strokeWidth="1.5" fill="none" />
      {/* Inner filled circle - complete (LIVE state) */}
      <circle cx="8" cy="8" r="5.5" fill="#01A925" />
    </svg>
  );
};

export default LiveIcon;
